var map = {
	"./act": 1522,
	"./act.tsx": 1522,
	"./gmat": 1523,
	"./gmat.tsx": 1523,
	"./gre": 1524,
	"./gre.tsx": 1524,
	"./ielts": 1525,
	"./ielts.tsx": 1525,
	"./ielts_general_training": 1526,
	"./ielts_general_training.tsx": 1526,
	"./lsat": 1527,
	"./lsat.tsx": 1527,
	"./mcat": 1528,
	"./mcat.tsx": 1528,
	"./sat": 1529,
	"./sat.tsx": 1529,
	"./toefl": 1530,
	"./toefl.tsx": 1530
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2544;
module.exports = webpackAsyncContext;